import { useDateTimeFormat } from '~/hooks';

export default function ExpenseItemDetails({ expenseItem }) {
  const dateTimeFormat = useDateTimeFormat();
  return [
    dateTimeFormat.format(expenseItem.date),
    expenseItem.member.name,
    expenseItem.project?.client?.name,
    expenseItem.project?.name,
    expenseItem.expenseCategory?.name,
  ]
    .filter(Boolean)
    .join(' - ');
}
